import React from "react"
import PropTypes from "prop-types"
import { Link as GatsbyLink } from "gatsby"
import { gaEventClasses } from "../../../constants/gtm.constants"
import clsx from "clsx"

const Link = props => {
    const {
        label,
        url: _url,
        href: _href,
        target,
        title,
        className = "",
        children,
        onClick,
        onFocus,
        onBlur,
        id,
        scrollToElementId,
        gaEventClass,
        gaEventLabel = "",
        tabIndex,
        variant,
        image,
    } = props
    const url = _url || _href
    const regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
    )
    const isExternallink = regex.test(url)
    let pageUrl
    if (url) {
        pageUrl = !url?.trim()?.endsWith("/") && !(url?.trim()?.endsWith(".pdf") || isExternallink) ? `${url}/` : url
    }
    let href = pageUrl
    if (pageUrl && scrollToElementId) {
        href = `${pageUrl}#${scrollToElementId}`
    } else if (!pageUrl && scrollToElementId) {
        href = `#${scrollToElementId}`
    }

    const targetWindow = target || (isExternallink ? "_blank" : "_self")

    const eventClassFinal = gaEventClass
        ? gaEventClass
        : isExternallink
        ? gaEventClasses.external_link
        : gaEventClasses.internal_link

    const _classNameFinal = className ? [className, eventClassFinal].join(" ") : eventClassFinal
    const classNameFinal = clsx(_classNameFinal, {
        "btn-primary": !image && variant === "primary",
        "btn-primary-dark": !image && variant === "primary-dark",
        "btn-secondary": !image && variant === "secondary",
        "btn-wrapper": !image && variant === "wrapper",
    })
    const _content = children || label

    const content = !!image ? (
        <img src={image.url} width={image.width} height={image.height} alt={image?.title || title || ""} />
    ) : (
        _content
    )

    if (!url && !scrollToElementId) {
        return <div className={classNameFinal}>{content}</div>
    }

    if (isExternallink) {
        return (
            <a
                href={href}
                target={targetWindow}
                className={classNameFinal}
                onFocus={onFocus}
                onBlur={onBlur}
                onClick={onClick}
                data-action-detail={gaEventLabel || href}
                title={title}
                id={id}
                tabIndex={tabIndex}
            >
                {content || children}
            </a>
        )
    } else {
        return (
            <GatsbyLink
                to={href}
                target={targetWindow}
                className={classNameFinal}
                onFocus={onFocus}
                onBlur={onBlur}
                onClick={onClick}
                data-action-detail={gaEventLabel || label || href}
                title={title}
                id={id}
                tabIndex={tabIndex}
            >
                {content || children}
            </GatsbyLink>
        )
    }
}

Link.propTypes = {
    sys: PropTypes.shape({
        id: PropTypes.string,
    }),
    label: PropTypes.string,
    url: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.any,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    scrollToElementId: PropTypes.string,
    id: PropTypes.string,
    gaEventClass: PropTypes.string,
    gaEventLabel: PropTypes.string,
    tabIndex: PropTypes.number,
    variant: PropTypes.oneOf(["primary", "primary-dark", "secondary", "wrapper"]),
    image: PropTypes.object,
}

export default Link
